import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import { KeyRound, Eye, EyeOff } from 'lucide-react';
import { useAuth } from '../../contexts/AuthContext';
import authApi from '../../services/api/authApi';
import { DEVE_TROCAR_SENHA_EVENT } from '../../services/core/apiClient';
const ModalTrocarSenha = () => {
    const { user, isAuthenticated, updateUser } = useAuth();
    const [visivel, setVisivel] = useState(false);
    const [senhaAtual, setSenhaAtual] = useState('');
    const [novaSenha, setNovaSenha] = useState('');
    const [confirmarSenha, setConfirmarSenha] = useState('');
    const [erro, setErro] = useState('');
    const [salvando, setSalvando] = useState(false);
    const [mostrarAtual, setMostrarAtual] = useState(false);
    const [mostrarNova, setMostrarNova] = useState(false);
    const [mostrarConfirmar, setMostrarConfirmar] = useState(false);
    useEffect(() => {
        setVisivel(isAuthenticated && !!user?.deve_trocar_senha);
    }, [isAuthenticated, user?.deve_trocar_senha]);
    // Reaparecer se o backend bloquear uma chamada por senha não trocada
    useEffect(() => {
        const handle = () => setVisivel(true);
        window.addEventListener(DEVE_TROCAR_SENHA_EVENT, handle);
        return () => window.removeEventListener(DEVE_TROCAR_SENHA_EVENT, handle);
    }, []);
    if (!visivel)
        return null;
    const handleSubmit = async (e) => {
        e.preventDefault();
        setErro('');
        if (!senhaAtual || !novaSenha || !confirmarSenha) {
            setErro('Preencha todos os campos.');
            return;
        }
        if (novaSenha !== confirmarSenha) {
            setErro('A nova senha e a confirmação não coincidem.');
            return;
        }
        if (novaSenha.length < 8) {
            setErro('A nova senha deve ter pelo menos 8 caracteres.');
            return;
        }
        if (novaSenha === senhaAtual) {
            setErro('A nova senha deve ser diferente da senha atual.');
            return;
        }
        setSalvando(true);
        try {
            await authApi.changePassword({
                username: user.username,
                senha_atual: senhaAtual,
                nova_senha: novaSenha,
            });
            updateUser({ ...user, deve_trocar_senha: false });
            setVisivel(false);
        }
        catch (err) {
            const msg = err?.response?.data?.mensagem ||
                err?.response?.data?.erro ||
                'Erro ao alterar a senha. Verifique a senha atual e tente novamente.';
            setErro(msg);
        }
        finally {
            setSalvando(false);
        }
    };
    const inputClass = 'w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 px-3 py-2 text-sm text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-icavi-500 pr-10';
    const renderField = (label, value, onChange, mostrar, setMostrar, autoCompleteValue = 'new-password') => (_jsxs("div", { children: [_jsx("label", { className: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1", children: label }), _jsxs("div", { className: "relative", children: [_jsx("input", { type: mostrar ? 'text' : 'password', value: value, onChange: e => onChange(e.target.value), className: inputClass, autoComplete: autoCompleteValue }), _jsx("button", { type: "button", onClick: () => setMostrar(!mostrar), className: "absolute inset-y-0 right-0 flex items-center px-3 text-gray-400 hover:text-gray-600 dark:hover:text-gray-200", tabIndex: -1, children: mostrar ? _jsx(EyeOff, { className: "h-4 w-4" }) : _jsx(Eye, { className: "h-4 w-4" }) })] })] }));
    return (_jsxs("div", { className: "fixed inset-0 z-[9999] overflow-y-auto", children: [_jsx("div", { className: "fixed inset-0 bg-black/60" }), _jsx("div", { className: "flex min-h-full items-center justify-center p-4", children: _jsxs("div", { className: "relative bg-white dark:bg-gray-800 rounded-lg shadow-xl w-full max-w-md", children: [_jsxs("div", { className: "flex items-center gap-3 p-6 border-b border-gray-200 dark:border-gray-700", children: [_jsx(KeyRound, { className: "h-6 w-6 text-icavi-600 shrink-0" }), _jsxs("div", { children: [_jsx("h3", { className: "text-lg font-semibold text-gray-900 dark:text-gray-100", children: "Troca de senha obrigat\u00F3ria" }), _jsx("p", { className: "text-xs text-gray-500 dark:text-gray-400 mt-0.5", children: "Por seguran\u00E7a, defina uma senha pessoal antes de continuar." })] })] }), _jsxs("form", { onSubmit: handleSubmit, className: "p-6 space-y-4", children: [renderField('Senha atual', senhaAtual, setSenhaAtual, mostrarAtual, setMostrarAtual, 'current-password'), renderField('Nova senha', novaSenha, setNovaSenha, mostrarNova, setMostrarNova), renderField('Confirmar nova senha', confirmarSenha, setConfirmarSenha, mostrarConfirmar, setMostrarConfirmar), erro && (_jsx("p", { className: "text-sm text-red-600 dark:text-red-400 bg-red-50 dark:bg-red-900/20 rounded-lg px-3 py-2", children: erro })), _jsx("div", { className: "pt-2 flex justify-end border-t border-gray-200 dark:border-gray-700", children: _jsx("button", { type: "submit", disabled: salvando, className: "inline-flex items-center gap-2 px-5 py-2.5 bg-icavi-600 hover:bg-icavi-700 disabled:opacity-60 text-white text-sm font-medium rounded-lg transition-colors", children: salvando ? 'Salvando...' : 'Salvar e Continuar' }) })] })] }) })] }));
};
export default ModalTrocarSenha;
